import { SensorsActionTypes } from '../types/sensors';
import { InConfigurationActionTypes } from '../types/in-configuration';
import { Filter, FilterOfValueType } from '../types/filters';
import { SenseiApi } from '../utils/api';
import { Sensor } from '../types/api';
import { CapturesActionTypes } from '../types/captures';
import { Choice } from '../types/choice';

// Fetch a list of one sensor and put it into the `SensorsStore`
export async function fetchSingleSensor(
  dispatch,
  jwtToken: string,
  sensorSerialNumber: string,
): Promise<Sensor> {
  dispatch({ type: SensorsActionTypes.SENSORS_LOAD_START });

  let sensor;
  try {
    sensor = await SenseiApi.sensorDetails(jwtToken, sensorSerialNumber);
  } catch (error) {
    dispatch({
      type: SensorsActionTypes.SENSORS_LOAD_ERROR,
      page: 'detail',
      error,
    });
    return;
  }

  dispatch({
    type: SensorsActionTypes.SENSORS_LOAD_COMPLETE,
    sensor,
  });
  return sensor;
}

// Fetch a list of all notes for a sensor
export async function fetchNotesForSensor(
  dispatch,
  jwtToken: string,
  serialNumber: Sensor['serial_number'],
) {
  dispatch({
    type: SensorsActionTypes.SENSORS_NOTES_LOAD_START,
  });

  let notes;
  try {
    notes = await SenseiApi.listNotes(jwtToken, serialNumber);
  } catch (error) {
    dispatch({
      type: SensorsActionTypes.SENSORS_NOTES_LOAD_ERROR,
      error,
    });
    return;
  }

  dispatch({
    type: SensorsActionTypes.SENSORS_NOTES_LOAD_COMPLETE,
    notes: notes.results,
  });
}

// Fetch a list of all captures for a sensor
export async function fetchCapturesForSensor(
  dispatch,
  jwtToken: string,
  sensorSerialNumber: Sensor['serial_number'],
  filters: Array<Filter>,
  search: string,
) {
  dispatch({
    type: SensorsActionTypes.SENSORS_CAPTURES_LOAD_START,
  });

  const status = filters.find((f) => f.definitionId === 'status') as
    | FilterOfValueType<Choice['id']>
    | undefined;
  const tags = filters.find((f) => f.definitionId === 'tags') as
    | FilterOfValueType<Array<Choice['id']>>
    | undefined;

  const accuracyRangeLessThan = filters.find(
    (i) => i.definitionId === 'total_accuracy' && i.operatorId === 'lt',
  ) as FilterOfValueType<string> | undefined;

  const accuracyRangeGreaterThan = filters.find(
    (i) => i.definitionId === 'total_accuracy' && i.operatorId === 'gt',
  ) as FilterOfValueType<string> | undefined;

  let params = {
    annotation_status: status ? status.value : undefined,
    tag_ids: tags ? tags.value.join(',') : undefined,
    accuracy_less_than: accuracyRangeLessThan
      ? accuracyRangeLessThan.value
      : undefined,
    accuracy_greater_than: accuracyRangeGreaterThan
      ? accuracyRangeGreaterThan.value
      : undefined,
  };
  if (search) {
    params['search'] = search;
  }

  let captures;
  try {
    captures = await SenseiApi.sensorCaptureList(
      jwtToken,
      sensorSerialNumber,
      params,
    );
  } catch (error) {
    dispatch({
      type: SensorsActionTypes.SENSORS_CAPTURES_LOAD_ERROR,
      error,
    });
    return;
  }

  dispatch({
    type: SensorsActionTypes.SENSORS_CAPTURES_LOAD_COMPLETE,
    captures: captures.results,
    sensorSerialNumber: sensorSerialNumber,
  });
}
